function interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {default: obj};
}
module.exports = interopRequireDefault(require("./build/cjs/index.js"));
